/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeRange } from './TimeRange';
import {
    TimeRangeFromJSON,
    TimeRangeFromJSONTyped,
    TimeRangeToJSON,
    TimeRangeToJSONTyped,
} from './TimeRange';
import type { Action } from './Action';
import {
    ActionFromJSON,
    ActionFromJSONTyped,
    ActionToJSON,
    ActionToJSONTyped,
} from './Action';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * A Scheduled location is a location within an activity where actions have to be performed between a defined timeframe. A planning scheduled location is typically used in a quotation process and only defines requested and planned timeframes, not actual.
 * @export
 * @interface PlannedScheduledLocation
 */
export interface PlannedScheduledLocation {
    /**
     * Indicates if an appointment is requested at the location.
     * @type {boolean}
     * @memberof PlannedScheduledLocation
     */
    isAppointmentRequested?: boolean;
    /**
     * Actions are describing WHAT has to be done at a specific location in the time frame defined for the location in the activity. There should be at least 1 action describing the what to be done for an activity. If actions would need a different schedule even at the same location, there should be different scheduled locations for those actions.
     * @type {Array<Action>}
     * @memberof PlannedScheduledLocation
     */
    actions?: Array<Action>;
    /**
     * Location where actions of the activity have to be executed. There is always a location for a scheduled Location. It can be limited to a country.
     * @type {Location}
     * @memberof PlannedScheduledLocation
     */
    location?: Location;
    /**
     * Earliest and latest datetime of the appointment at the location.
     * @type {TimeRange}
     * @memberof PlannedScheduledLocation
     */
    appointmentTimeRange?: TimeRange;
    /**
     * Requested start time range for the location.
     * @type {TimeRange}
     * @memberof PlannedScheduledLocation
     */
    requestedStartTimeRange?: TimeRange;
    /**
     * Requested end time range for the location.
     * @type {TimeRange}
     * @memberof PlannedScheduledLocation
     */
    requestedEndTimeRange?: TimeRange;
    /**
     * Planned start time range for the location.
     * @type {TimeRange}
     * @memberof PlannedScheduledLocation
     */
    plannedStartTimeRange?: TimeRange;
    /**
     * Planned end time range for the location.
     * @type {TimeRange}
     * @memberof PlannedScheduledLocation
     */
    plannedEndTimeRange?: TimeRange;
}

/**
 * Check if a given object implements the PlannedScheduledLocation interface.
 */
export function instanceOfPlannedScheduledLocation(value: object): value is PlannedScheduledLocation {
    return true;
}

export function PlannedScheduledLocationFromJSON(json: any): PlannedScheduledLocation {
    return PlannedScheduledLocationFromJSONTyped(json, false);
}

export function PlannedScheduledLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannedScheduledLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'isAppointmentRequested': json['isAppointmentRequested'] == null ? undefined : json['isAppointmentRequested'],
        'actions': json['actions'] == null ? undefined : ((json['actions'] as Array<any>).map(ActionFromJSON)),
        'location': json['location'] == null ? undefined : LocationFromJSON(json['location']),
        'appointmentTimeRange': json['appointmentTimeRange'] == null ? undefined : TimeRangeFromJSON(json['appointmentTimeRange']),
        'requestedStartTimeRange': json['requestedStartTimeRange'] == null ? undefined : TimeRangeFromJSON(json['requestedStartTimeRange']),
        'requestedEndTimeRange': json['requestedEndTimeRange'] == null ? undefined : TimeRangeFromJSON(json['requestedEndTimeRange']),
        'plannedStartTimeRange': json['plannedStartTimeRange'] == null ? undefined : TimeRangeFromJSON(json['plannedStartTimeRange']),
        'plannedEndTimeRange': json['plannedEndTimeRange'] == null ? undefined : TimeRangeFromJSON(json['plannedEndTimeRange']),
    };
}

export function PlannedScheduledLocationToJSON(json: any): PlannedScheduledLocation {
    return PlannedScheduledLocationToJSONTyped(json, false);
}

export function PlannedScheduledLocationToJSONTyped(value?: PlannedScheduledLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isAppointmentRequested': value['isAppointmentRequested'],
        'actions': value['actions'] == null ? undefined : ((value['actions'] as Array<any>).map(ActionToJSON)),
        'location': LocationToJSON(value['location']),
        'appointmentTimeRange': TimeRangeToJSON(value['appointmentTimeRange']),
        'requestedStartTimeRange': TimeRangeToJSON(value['requestedStartTimeRange']),
        'requestedEndTimeRange': TimeRangeToJSON(value['requestedEndTimeRange']),
        'plannedStartTimeRange': TimeRangeToJSON(value['plannedStartTimeRange']),
        'plannedEndTimeRange': TimeRangeToJSON(value['plannedEndTimeRange']),
    };
}

